<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-menu"></i> {{menusList.menusList_0}}
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<div class="handle-box">
					<el-row>
						<el-col :span="20">
							<div class="grid-content bg-purple">
								<el-input v-model="query.name" clearable :placeholder="menusList.menusList_1" class="handle-input mr10"></el-input>
							</div>
						</el-col>
						<el-col :span="4">
							<div class="grid-content bg-purple-light">
								<el-button :disabled="!hasPerms(buttonPerms.searchPerms)" type="warning" icon="el-icon-search" @click="handleSearch">{{menusList.menusList_2}}</el-button>
								<el-button :disabled="!hasPerms(buttonPerms.addPerms)" type="primary" icon="el-icon-plus" @click="handleAdd">{{menusList.menusList_3}}</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
				<!--表格树内容栏-->
				<el-table :data="tableTreeDdata" border class="table" highlight-current-row row-key="id" v-loading="loading"
				 key :element-loading-text="menusList.menusList_4">
					<el-table-column prop="id" header-align="center" align="center" width="100" label="ID">
					</el-table-column>
					<table-tree-column prop="name" header-align="center" treeKey="id" :label="menusList.menusList_5">
					</table-tree-column>
					<el-table-column header-align="center" align="center" width="80" :label="menusList.menusList_6">
						<template slot-scope="scope">
							<i :class="scope.row.icon || ''"></i>
						</template>
					</el-table-column>
					<el-table-column prop="type" header-align="center" align="center" width="100" :label="menusList.menusList_7">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.type === 0" size="small">{{menusList.menusList_8}}</el-tag>
							<el-tag v-else-if="scope.row.type === 1" size="small" type="success">{{menusList.menusList_9}}</el-tag>
							<el-tag v-else-if="scope.row.type === 2" size="small" type="info">{{menusList.menusList_10}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="parentName" header-align="center" align="center" width="120" :label="menusList.menusList_11">
					</el-table-column>
					<el-table-column prop="url" header-align="center" align="center" :show-overflow-tooltip="true" :label="menusList.menusList_12">
					</el-table-column>
					<el-table-column prop="perms" header-align="center" align="center" :show-overflow-tooltip="true"
					 :label="menusList.menusList_13">
					</el-table-column>
					<el-table-column prop="orderNum" header-align="center" width="80" align="center" :label="menusList.menusList_14">
					</el-table-column>
					<el-table-column align="center" width="180" :label="menusList.menusList_15">
						<template slot-scope="scope">
							<el-button :disabled="!hasPerms(buttonPerms.editPerms)" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">{{menusList.menusList_16}}</el-button>
							<el-button :disabled="!hasPerms(buttonPerms.deletePerms)" type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index,scope.row)">{{menusList.menusList_17}}</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
			<!-- 新增修改界面 -->
			<div v-if="dialogVisible">
				<el-dialog :title="!dataForm.id ? menusList.menusList_18 : menusList.menusList_19" width="40%"
			 :visible.sync="dialogVisible" :close-on-click-modal="false">
				<el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="submitForm()" label-width="130px"
				 :size="size" style="text-align:left;">
					<el-form-item :label="menusList.menusList_20" prop="type">
						<el-radio-group v-model="dataForm.type">
							<el-radio v-for="(type, index) in menuTypeList" :label="index" :key="index">{{ type }}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item :label="menuTypeList[dataForm.type] + menusList.menusList_21" prop="name">
						<el-input v-model="dataForm.name" maxlength="10"></el-input>
					</el-form-item>
					<el-form-item :label="menusList.menusList_44" prop="parentName">
						<popup-tree-input :data="popupTreeData" :props="popupTreeProps" :prop="dataForm.parentName==null||dataForm.parentName==''?menusList.menusList_22:dataForm.parentName"
						 :nodeKey="''+dataForm.parentId" :currentChangeHandle="handleTreeSelectChange">
						</popup-tree-input>
					</el-form-item>
					<el-form-item v-if="dataForm.type !== 0" :label="menusList.menusList_23" prop="perms">
						<el-input v-model="dataForm.perms" placeholder="如: users:usersList:add, users:usersList:edit, users:usersList:delete" maxlength="100"></el-input>
					</el-form-item>
					<el-form-item v-if="dataForm.type !== 0" :label="menusList.menusList_24" prop="url">
						<el-row>
							<el-col :span="22">
								<el-input v-model="dataForm.url" maxlength="100"></el-input>
							</el-col>
							<el-col :span="2">
								<el-tooltip placement="top" effect="light" style="padding: 10px;">
									<div slot="content">
										<p>{{menusList.menusList_25}}</p>
										<p>{{menusList.menusList_26}}</p>
										<p>{{menusList.menusList_27}}</p>
										<p>{{menusList.menusList_28}}</p>
									</div>
									<i class="el-icon-warning"></i>
								</el-tooltip>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item v-if="dataForm.type !== 2" :label="menusList.menusList_29" prop="orderNum">
						<el-input-number v-model="dataForm.orderNum" controls-position="right" :min="0" :label="menusList.menusList_29"></el-input-number>
					</el-form-item>
					<el-form-item v-if="dataForm.type !== 2" :label="menusList.menusList_30" prop="icon">
						<el-row>
							<el-col :span="22">
								<el-input v-model="dataForm.icon" v-popover:iconListPopover :readonly="false" :placeholder="menusList.menusList_31"
								 class="icon-list__input"></el-input>
							</el-col>
							<el-col :span="2" class="icon-list__tips">
								<!-- <fa-icon-tooltip /> -->
							</el-col>
						</el-row>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button :size="size" @click="dialogVisible = false">{{menusList.menusList_32}}</el-button>
					<el-button :size="size" type="primary" @click="submitForm()">{{menusList.menusList_33}}</el-button>
				</span>
			</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import TableTreeColumn from "@/pages/core/TableTreeColumn";
	import PopupTreeInput from "@/components/PopupTreeInput";
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'menusList',
		inject: ['reload'], //在子组件中通过inject调用
		components: {
			PopupTreeInput,
			TableTreeColumn
		},
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					addPerms: 'menus:menusList:add', //新增权限标识
					searchPerms: 'menus:menusList:search', //搜索权限标识
					viewPerms: 'menus:menusList:view', //查看权限标识
					editPerms: 'menus:menusList:edit', //编辑权限标识
					deletePerms: 'menus:menusList:delete', //删除权限标识
					batchdelPerms: 'menus:menusList:batchdel', //批量删除权限标识
					exportPerms: 'menus:menusList:export', //导出权限标识

					disabled: false
				},

				web_suuid: sessionStorage.getItem('ms_web_suuid'), //web侧 登录ID


				query: {
					name: ''
				},
				loading: false,
				size: "small",
				tableTreeDdata: [],
				dialogVisible: false,
				menuTypeList: ["目录","菜单","按钮"],
				dataForm: {
					id: 0,
					type: 1,
					name: "",
					parentId: 0,
					parentName: "",
					url: "",
					perms: "",
					orderNum: 0,
					icon: "",
					iconList: []
				},
				dataRule: {
					name: [{
						required: true,
						// message: this.menusList.menusList_34,
						trigger: "blur"
					}]
				},
				popupTreeData: [],
				popupTreeProps: {
					label: "name",
					children: "children"
				},
				menusList: {
					menusList_0: "菜单管理",
					menusList_1: "请搜索菜单名称",
					menusList_2: "搜索",
					menusList_3: "新增",
					menusList_4: "拼命加载中",
					menusList_5: "菜单名称",
					menusList_6: "图标",
					menusList_7: "类型",
					menusList_8: "目录",
					menusList_9: "菜单",
					menusList_10: "按钮",
					menusList_11: "上级菜单",
					menusList_12: "菜单URL",
					menusList_13: "授权标识",
					menusList_14: "排序",
					menusList_15: "操作",
					menusList_16: "编辑",
					menusList_17: "删除",
					menusList_18: "新增菜单",
					menusList_19: "编辑菜单",
					menusList_20: "菜单类型：",
					menusList_21: "名称：",
					menusList_22: "顶级菜单",
					menusList_23: "授权标识：",
					menusList_24: "菜单路由：",
					menusList_25: "URL格式：",
					menusList_26: "1.常规业务开发的功能URL，如用户管理，pages目录下页面路径为 /users/usersList, 此处填写 /users/usersList。",
					menusList_27: "2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http:// 不可省略。",
					menusList_28: "示例：用户管理：/users/usersList 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000",
					menusList_29: "排序编号：",
					menusList_30: "菜单图标：",
					menusList_31: "菜单图标名称（如：el-icon-s-home）",
					menusList_32: "返回",
					menusList_33: "确认",
					menusList_34: "名称不能为空",
					menusList_35: "请求失败",
					menusList_36: "您确定要删除吗？",
					menusList_37: "提示",
					menusList_38: "删除失败",
					menusList_39: "删除成功",
					menusList_40: "确认提交吗？",
					menusList_41: "菜单名称不能重复新增",
					menusList_42: "操作失败",
					menusList_43: "操作成功",
					menusList_44: "上级菜单："
				},
			};
		},
		computed: {
		},
		created() {
			this.findTreeData(); //获取当前列表数据
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			// 获取菜单管理数据
			findTreeData() {

				//清空table表格数据
				this.tableTreeDdata =[];

				this.loading = true; //初始化加载loading效果
				const self = this;
				var postUrl = 'WCF/WEB/svcBAG.svc/GET_BAG_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sUAAID: self.web_suuid, //web侧 登录ID  tihs.web_suuid
							sNAME: self.query.name.trim() //菜单名称
						}
					)
					.then((response) => {
						this.loading = false; //取消loading效果
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;

						if (resCount > 0) {
							//渲染数据 List
							let optionsOneMenu = response.data.KKDT;
							optionsOneMenu.forEach(item => {

								const addnew = {
									id: parseInt(item.BAGMSID),
									name: item.BAGNAME,
									type: parseInt(item.BAGTYPE),
									icon: item.BAGICON,
									parentId: parseInt(item.BAGFAER),
									parentName: item.BAGBAGN,
									url: item.BAGPATH,
									perms: item.BAGPERM,
									orderNum: item.BAGSORT,
									level: 0,
									children: []
								}

								//根据一级菜单ID获取二级菜单
								const self = this;
								var postUrl = 'WCF/WEB/svcBAG.svc/GET_BAG_LIST_BYMENUID';
								//网络请求接口
								this.$axios.post(
										//请求的url
										postUrl,
										//请求参数
										{
											sUAAID: self.web_suuid, //web侧 登录ID  tihs.web_suuid
											sMENUID: item.BAGMSID //一级菜单ID
										}
									)
									.then((response) => {
										//请求成功返回的数据
										let resCount = response.data.KKDTCOUNT;
										if (resCount > 0) {
											let optionsTwoMenu = response.data.KKDT;

											optionsTwoMenu.forEach((twoitem, twoindex) => {
												addnew.children.push({
													id: parseInt(twoitem.BAGMSID),
													name: twoitem.BAGNAME,
													type: parseInt(twoitem.BAGTYPE),
													icon: twoitem.BAGICON,
													parentId: parseInt(twoitem.BAGFAER),
													parentName: twoitem.BAGBAGN,
													url: twoitem.BAGPATH,
													perms: twoitem.BAGPERM,
													orderNum: twoitem.BAGSORT,
													level: 1,
													children: []
												})

												//根据二级菜单ID获取三级菜单
												const self = this;
												var postUrl = 'WCF/WEB/svcBAG.svc/GET_BAG_LIST_BYMENUID';
												//网络请求接口
												this.$axios.post(
														//请求的url
														postUrl,
														//请求参数
														{
															sUAAID: self.web_suuid, //web侧 登录ID  tihs.web_suuid
															sMENUID: twoitem.BAGMSID //二级菜单ID
														}
													)
													.then((response) => {
														//请求成功返回的数据
														let resCount = response.data.KKDTCOUNT;
														if (resCount > 0) {
															let optionsThreeMenu = response.data.KKDT;

															optionsThreeMenu.forEach((threeitem, threeindex) => {
																addnew.children[twoindex].children.push({
																	id: parseInt(threeitem.BAGMSID),
																	name: threeitem.BAGNAME,
																	type: parseInt(threeitem.BAGTYPE),
																	icon: threeitem.BAGICON,
																	parentId: parseInt(threeitem.BAGFAER),
																	parentName: threeitem.BAGBAGN,
																	url: threeitem.BAGPATH,
																	perms: threeitem.BAGPERM,
																	orderNum: threeitem.BAGSORT,
																	level: 2
																})
															})
														}
													})
													.catch((error) => {
														this.$message({
															message: this.menusList.menusList_35, //请求失败
															type: 'error'
														});
													});
											})

										}
									})
									.catch((error) => {
										this.$message({
											message: this.menusList.menusList_35, //请求失败
											type: 'error'
										});
									});


								this.tableTreeDdata.push(addnew);
								this.popupTreeData = this.getParentMenuTree(this.tableTreeDdata);

							})
						} else {
							this.tableTreeDdata = []; //数据数组
						}
					})
					.catch((error) => {
						this.loading = false; //取消loading效果
						this.$message({
							message: this.menusList.menusList_35, //请求失败
							type: 'error'
						});
					});
			},
			// 获取上级菜单树
			getParentMenuTree: function(tableTreeDdata) {
				let parent = {
					parentId: 0,
					name: this.menusList.menusList_22,
					children: tableTreeDdata
				};

				return [parent];
			},
			// 触发搜索按钮
			handleSearch() {
				this.$set(this.query, 'pageIndex', 1);
				this.findTreeData();
			},
			// 删除单个菜单操作
			handleDelete(index, row) {
				//二次确认删除
				this.$confirm(this.menusList.menusList_36, this.menusList.menusList_37, {
						type: 'warning'
					})
					.then(() => {

						//删除接口
						const self = this;
						var postUrl = 'WCF/WEB/svcBAG.svc/DEL_BAG_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sUAAID: self.web_suuid, //web侧 登录ID  tihs.web_suuid
									sBAGID: row.id //BAGMSID
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: this.menusList.menusList_38, //删除失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success(this.menusList.menusList_39); //删除成功
										//this.tableData.splice(index, 1);
										//刷新当前页面
										this.$parent.getSideBar();
										this.findTreeData();
									}
								} else {
									this.$message({
										message: this.menusList.menusList_35, //请求失败
										type: 'error'
									});
								}
							})
					})
					.catch((error) => {
						console.log("cancel"); //取消
					});
			},
			// 显示新增界面
			handleAdd: function() {
				this.dialogVisible = true;
				this.dataForm = {
					id: 0,
					type: 1,
					typeList: [this.menusList.menusList_8, this.menusList.menusList_9, this.menusList.menusList_10],
					name: "",
					parentId: 0,
					parentName: "",
					url: "",
					perms: "",
					orderNum: 0,
					icon: "",
					iconList: []
				};
			},
			// 显示编辑界面
			handleEdit: function(row) {
				this.dialogVisible = true;
				Object.assign(this.dataForm, row);
			},
			// 菜单树选中
			handleTreeSelectChange(data, node) {
				this.dataForm.parentId = data.id;
				this.dataForm.parentName = data.name;
			},
			// 表单提交
			submitForm() {
				this.$refs["dataForm"].validate(valid => {
					if (valid) {
						this.$confirm(this.menusList.menusList_40, this.menusList.menusList_37, {}).then(() => {
							this.editLoading = true;

							const self = this;
							var postUrl = 'WCF/WEB/svcBAG.svc/SAVE_BAG';

							let params = Object.assign({}, self.dataForm);

							//网络请求接口
							this.$axios.post(
									//请求的url
									postUrl,
									//请求参数
									{
										sUAAID: self.web_suuid, //web侧 登录ID  tihs.web_suuid
										sBAGMSID: params.id, //菜单ID
										sBAGTYPE: params.type, //菜单类型
										sBAGNAME: params.name, //菜单名称
										sBAGFAER: params.parentId, //上级菜单ID
										sBAGBAGN: params.parentName, //上级菜单名称
										sBAGPATH: params.url, //菜单路由
										sBAGPERM: params.perms, //授权标识
										sBAGSORT: params.orderNum, //排序编号
										sBAGICON: params.icon //菜单图标
									}
								)
								.then((response) => {
									this.editLoading = false;
									//请求成功返回的数据
									let resStatus = response.status; //200 代表请求成功
									let resKKSTR = response.data.KKSTR;

									if (resStatus == "200") {
										if (resKKSTR == "E") {
											this.$message({
												message: this.menusList.menusList_41, //菜单名称不能重复新增
												type: 'error'
											});
										} else if (resKKSTR == "N") {
											this.$message({
												message: this.menusList.menusList_42, //操作失败
												type: 'error'
											});
										} else if (resKKSTR == "Y") {
											this.$message.success(this.menusList.menusList_43); // 操作成功
											this.$refs["dataForm"].resetFields();
											this.dialogVisible = false;
											this.$parent.getSideBar();
										}
									} else {
										this.$message({
											message: this.menusList.menusList_35, //请求失败
											type: 'error'
										});
									}
									//获取菜单管理数据
									this.findTreeData();
								})
								.catch((error) => {
									this.$message({
										message: this.menusList.menusList_35, //请求失败
										type: 'error'
									});
								});
						});
					}
				});
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 20%;
	}
	.el-dialog__footer {
		text-align: center;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
	    margin-bottom: 28px;
	}
	.el-form-item__error {
	    color: #F56C6C;
	    font-size: 13px;
	    line-height: 2;
	    padding-top: 4px;
	    position: absolute;
	    top: 100%;
	    left: 0;
	}
</style>
